<template>
  <div class="footer">
    <div class="footer-wrapper">
            
     <div class="link-top"></div>

      <div class="top-wrapper">
        <div class="left-wrapper">
          <!-- <div class="logo">
            <img src="@/assets/logo/logo.png" alt="" />
          </div> -->
          <div class="third">
            <div class="desc">
            {{ $t("footer.title.desc") }}
          </div>
            <div
              class="right-item"
              v-for="(item, index) in iconList"
              :key="index"
            >
              <span @click="goto(item.url)">
                <!-- <i class="iconfont ic">{{ item.icon }}</i> -->
                 <i class="iconfont ic" :class="item.icon"></i>
              </span>
            </div>
          </div>
        </div>
         <div class="bottom-wrapper">
            <a href="/privacy-service/privacy.html"> Our Privacy Policy </a> 
           </div>
              <div class="bottom-wrapper">
            <a href="/privacy-service/service.html"> Our Terms of Use</a>
           </div>
          <!-- <div class="bottom-wrapper">
             You can by the support team via email at huojiecs@gmail.com
           </div> -->
        <div class="right-wrapper">
          <!-- <div class="menu-item">
            <div class="title">{{ $t("footer.title.about.t1") }}</div>
            <div class="item">{{ $t("footer.title.about.item_1") }}</div>
          </div> -->
          <!-- <div class="menu-item">
            <div class="title">社区</div>
            <div class="item">Privacy Policy</div>
            <div class="item">Terms and Conditions</div>
          </div> -->
          <!-- <div class="menu-item">
            <div class="title">Newsletter</div>
            <div class="item line">
              Sign up for our newsletter to get the latest news in your inbox.
            </div>
            <div class="item">
              <input type="text" placeholder="Your email address" />
            </div>
          </div> -->
         
        </div>
      </div>
      <div class="bottom-wrapper">@2026 TwitterUTools. All Right Reserved</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "FooterNav",
  data() {
    return {
      iconList: [
        { icon: "icon-tuitetwitter43", url: "https://twitter.com/good6_api" },
        { icon: "icon-discord", url: "https://discord.gg/VEKBj3fT9G" },
        { icon: "icon-telegram", url: "https://t.me/Yang0619" },
        // { icon: "icon-Emailus", url: "huojiecs@gmail.com" },
      ],
    };
  },
  methods: {
    goto(url) {
      if (url == "email") {
        window.open("mailto:huojiecs@gmail.com", "_blank"); // 新窗口打开外链接
      } else {
        window.open(url, "_blank"); // 新窗口打开外链接
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

* {
  margin: 0;
  padding: 0;
  text-decoration: none;
}

.footer {
  width: 100%;
  background: #0c122d;
  border-top: 1px solid rgba(148, 163, 184, 0.1);
  min-width: 375px;
  padding: 60px 0 30px;
  
  .footer-wrapper {
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding: 0 24px;

    .top-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 40px;
      
      .left-wrapper {
        flex: 1;
        
        .logo {
          img {
            width: 180px;
            height: auto;
            opacity: 0.9;
            transition: opacity 0.3s ease;
            
            &:hover {
              opacity: 1;
            }
          }
        }
        
        .desc {
          margin-top: 16px;
          max-width: 400px;
          font-size: 14px;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          font-weight: 400;
          color: #94a3b8;
          line-height: 1.6;
        }
        
        .third {
          margin-top: 24px;
          display: flex;
          gap: 16px;
          
          .right-item {
            display: flex;
            
            span {
              width: 40px;
              height: 40px;
              border-radius: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              background: rgba(59, 130, 246, 0.1);
              border: 1px solid rgba(59, 130, 246, 0.2);
              cursor: pointer;
              transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
              
              .ic {
                font-size: 20px;
                color: #3b82f6;
                margin: 0;
                transition: all 0.3s ease;
              }
              
              &:hover {
                background: rgba(59, 130, 246, 0.2);
                transform: translateY(-2px);
                box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
                
                .ic {
                  transform: scale(1.1);
                }
              }
            }
          }
        }
      }
      
      .right-wrapper {
        display: flex;
        gap: 60px;
        
        .menu-item {
          display: flex;
          flex-direction: column;
          
          .title {
            font-size: 16px;
            font-family: 'Inter', sans-serif;
            font-weight: 600;
            color: #f1f5f9;
            line-height: 24px;
            margin-bottom: 16px;
          }
          
          .item {
            margin-top: 12px;
            font-size: 14px;
            font-family: 'Inter', sans-serif;
            font-weight: 400;
            color: #94a3b8;
            line-height: 20px;
            cursor: pointer;
            transition: color 0.2s ease;
            
            &:hover {
              color: #3b82f6;
            }

            input {
              width: 255px;
              height: 40px;
              background: rgba(15, 23, 42, 0.6);
              border: 1px solid rgba(148, 163, 184, 0.2);
              border-radius: 8px;
              padding: 0 16px;
              color: #e4e4e7;
              font-size: 14px;
              transition: all 0.2s ease;
              
              &:focus {
                outline: none;
                border-color: rgba(59, 130, 246, 0.5);
                background: rgba(15, 23, 42, 0.8);
                box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
              }
              
              &::placeholder {
                color: #64748b;
              }
            }
          }
          
          .line {
            width: 243px;
            font-size: 14px;
            color: #94a3b8;
            line-height: 1.6;
          }
        }
      }
    }
    
    .link-top {
      width: 100%;
      height: 1px;
      background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.2), transparent);
      margin: 40px 0 24px;
    }
    
    .bottom-wrapper {
      margin-top: 8px;
      font-size: 14px;
      font-family: 'Inter', sans-serif;
      font-weight: 400;
      color: #64748b;
      line-height: 20px;
      text-align: center;
      
      a {
        color: #94a3b8;
        text-decoration: none;
        transition: color 0.2s ease;
        
        &:hover {
          color: #3b82f6;
          text-decoration: underline;
        }
      }
    }

    @media only screen and (max-width: 768px) {
      padding: 0 16px;
      
      .top-wrapper {
        flex-direction: column;
        align-items: flex-start;
        gap: 32px;
      }
      
      .left-wrapper {
        width: 100%;
        
        .third {
          flex-wrap: wrap;
          gap: 12px;
          
          .right-item {
            margin: 0;
          }
        }
      }
      
      .right-wrapper {
        width: 100%;
        flex-direction: column;
        gap: 24px;
      }
      
      .desc {
        font-size: 13px !important;
      }
      
      .bottom-wrapper {
        font-size: 12px;
      }
    }
  }
}
</style>